
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getCandidatestatus} from 'sr/utils/api/masterData/candidatestatus/getCandidatestatus'
export const fetchcandidatestatus = createAsyncThunk(
  'getCandidatestatus',
  async () => {
    const response = await getCandidatestatus()
    return response?.data
  }
)


